import React from "react";

export const includedFormats = (t) => [
  t.audio_format || "MP3",
  t.stems_available ? "WAV + Stems" : (t.wav_available && t.audio_format !== "WAV" ? "WAV" : null),
].filter(Boolean);

export const IncludedFormats = ({ track, className = "" }) => (
  <span data-testid={`included-${track.id}`} title="Included with this exclusive"
    className={`font-mono uppercase tracking-wide text-[#e2ff31] whitespace-nowrap ${className}`}>
    {includedFormats(track).join(" · ")}
  </span>
);
